import { Eye } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useAuth } from '@/features/auth/use-auth'
import { useImpersonation } from '@/features/auth/impersonation'
import { logout } from '@/lib/firebase'

/** Shown for the whole session when a platform admin is signed in as this user. */
export function ImpersonationBanner() {
  const { user } = useAuth()
  const impersonation = useImpersonation()
  if (!impersonation) return null

  const exit = async () => {
    await logout()
    window.close() // works when the admin panel opened this tab
    window.location.replace('/login')
  }

  return (
    <div role="status" className="flex flex-wrap items-center gap-x-4 gap-y-2 border-b border-amber-500/40 bg-amber-400/20 px-4 py-2 text-sm md:px-6">
      <Eye className="size-4 shrink-0" aria-hidden />
      <p className="min-w-0 flex-1">
        <span className="font-medium">Impersonating {user?.email || user?.displayName || user?.uid}.</span>{' '}
        <span className="text-muted-foreground">
          Signed in by {impersonation.adminEmail || impersonation.adminUid}. Everything you do here happens as this user.
        </span>
      </p>
      <Button size="sm" variant="outline" onClick={exit}>
        Exit
      </Button>
    </div>
  )
}
